import React, { useState } from "react";
import { object, shape } from "prop-types";
import get from "lodash/get";
import { useDispatch } from "react-redux";

import ScrollToTop from "../../atoms/back-to-top-button";
import { getLoadMoreStories } from "../../utils";
import List from "../../rows/list";

import "./author.m.css";

export const AuthorPage = (props) => {
  const authorCollection = get(props, ["data", "authorCollection"], {});
  const [storiesToRender, setStoriesToRender] = useState(8);
  const [authorPageStories, setStories] = useState(authorCollection.items.map((item) => item.story));

  const dispatch = useDispatch();

  const setLoading = (isloading) => {
    dispatch(isloading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" });
  };

  const getMoreStories = async () => {
    setLoading(true);
    await getLoadMoreStories({
      offset: storiesToRender,
      limit: 4,
      authorId: props.data.author.id,
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: authorPageStories,
    });
    setLoading(false);
  };

  return (
    <div className="container" styleName="wrapper">
      <List
        stories={authorPageStories.slice(0, storiesToRender)}
        showLoadmore={authorPageStories.length > storiesToRender}
        loadMoreStories={getMoreStories}
        authorInfo={props.data.author}
      />
      <ScrollToTop />
    </div>
  );
};

AuthorPage.propTypes = {
  data: shape({
    author: object,
    authorCollection: object,
  }),
};
